'use client'

import Link from 'next/link'
import { ArrowRight } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { marketplaceClips } from '@/lib/copy/marketplace-clips'
import { useReserve } from './reserve-context'

// Sticky early-access basket. Rendered once at the /marketplace layout level so
// it follows the visitor across the library and clip pages. Hidden until at
// least one clip is reserved. Entrance gated behind motion-safe.

export function ReserveBar() {
  const { reserved, clear } = useReserve()
  const count = reserved.size
  const total = marketplaceClips
    .filter((c) => reserved.has(c.id))
    .reduce((sum, c) => sum + c.price, 0)

  if (count === 0) return null

  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-4 z-40 flex justify-center px-4 motion-safe:animate-in motion-safe:slide-in-from-bottom-4">
      <div className="pointer-events-auto flex w-full max-w-xl items-center justify-between gap-4 rounded-2xl border border-white/10 bg-brand-navy px-4 py-3 text-white shadow-2xl">
        <div className="min-w-0">
          <p className="text-sm font-semibold">
            {count} {count === 1 ? 'clip' : 'clips'} reserved
            <span className="ml-2 font-normal text-white/70">${total} est. license</span>
          </p>
          <p className="truncate text-xs text-white/60">
            Early access opens the checkout + your shoppable export.
          </p>
        </div>
        <div className="flex shrink-0 items-center gap-1">
          <button
            type="button"
            onClick={clear}
            className="rounded-full px-3 py-2 text-xs text-white/70 transition-colors hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-lime"
          >
            Clear
          </button>
          <Button asChild className="bg-brand-lime text-brand-navy hover:bg-brand-lime/90">
            <Link href="/contact?ref=marketplace">
              Get early access
              <ArrowRight className="ml-1.5 h-4 w-4" />
            </Link>
          </Button>
        </div>
      </div>
    </div>
  )
}
